import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=25009f1d&scoped=true&"
import script from "./SectionHeading.vue?vue&type=script&lang=ts&"
export * from "./SectionHeading.vue?vue&type=script&lang=ts&"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&id=25009f1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25009f1d",
  null
  
)

export default component.exports